import { ArrowRight } from 'lucide-react';
import { useDlResults } from '@/hooks/useDlResults';
import { safeHref } from '@/lib/safeUrl';

const AlertBar = () => {
  const { enabled, alert_text, url } = useDlResults();
  if (!enabled || !alert_text.trim()) return null;
  return (
    <div role="region" aria-label="Ważny komunikat" style={{ backgroundColor: '#e8231a' }}>
      <a
        href={safeHref(url, '#')}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center gap-2 py-2 px-4 text-center text-sm font-bold text-white hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-inset"
      >
        <span aria-hidden="true">🏆</span>
        <span>{alert_text}</span>
        <ArrowRight className="w-4 h-4" aria-hidden="true" />
      </a>
    </div>
  );
};

export default AlertBar;
